<template>
    <button type="button" class="outline-none appearance-none rounded-full font-main border"
        :style="{ minWidth: `${minWidth}px` }" :class="buttonClass" :disabled="disabled">
        <slot></slot>
    </button>
</template>

<script>
import Utility from '@/helper/Utility';
import { computed, defineComponent, useCssModule } from 'vue';

export default defineComponent({
    props: {
        disabled: {
            type: Boolean
        },
        color: {
            type: String,
            default: "orange"
        },
        textColor: {
            type: String,
            default: "text-white" // tailwind class
        },
        disabledColor: {
            type: String,
            default: "a-gray-c8c7c6"
        },
        disabledTextColor: {
            type: String,
            default: "text-white" // tailwind class
        },
        outline: {
            type: Boolean
        },
        block: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: "md"
        },
        minWidth: {
            type: Number
        },
        borderType: {
            type: String
        }
    },
    setup: function (props) {
        const cssClasses = useCssModule("classes")

        const buttonClass = computed(() => {
            // initial class
            let cls = [cssClasses.btn]

            if (props.outline) {
                cls.push(cssClasses["btn-outline-" + props.color])
                cls.push("bg-white")
                if (props.borderType && props.borderType == "dashed") {
                    cls.push('border-dashed')
                }
            } else {
                if (props.disabled) {
                    cls.push(cssClasses["btn-disabled-" + props.disabledColor])
                    cls.push(props.disabledTextColor)
                } else {
                    cls.push(cssClasses["btn-" + props.color])
                    cls.push(props.textColor)
                }
            }

            if (props.block) {
                cls.push('w-full')
            }

            // size
            if (!Utility.isEmptyStr(props.size)) {
                cls.push(cssClasses["btn-" + props.size])
            } else {
                cls.push(cssClasses["btn-md"])
            }
            return cls
        })

        return {
            buttonClass
        }
    }
})
</script>

<style lang="scss" scoped module="classes">
.btn {
    @apply font-main;

    &.btn-disabled-a-gray-c8c7c6 {
        @apply bg-a-gray-c8c7c6 border-a-gray-c8c7c6;
    }

    &.btn-disabled-a-gray-787878 {
        @apply bg-a-gray-787878 border-a-gray-787878;
    }

    &.btn-disabled-a-gray-e5e5e5 {
        @apply bg-a-gray-e5e5e5 border-a-gray-e5e5e5;
    }

    //#sizes
    &.btn-sm {
        @apply py-1 px-2 text-12 leading-3;
    }

    &.btn-md {
        @apply py-2 px-4 text-15;
    }

    &.btn-md-half {
        @apply py-2 px-4 text-15 h-10;
    }

    &.btn-md-half2 {
        @apply py-2 px-4 text-14 h-10;
    }

    &.btn-lg {
        @apply py-2 px-4 text-18 h-45px;
    }

    //#endregion sizes

    //#region colors
    &.btn-orange {
        @apply bg-a-orange-fe5000 border-a-orange-fe5000;

        &:hover {
            @apply ring-a-orange-fe5000;
        }
    }

    &.btn-outline-orange {
        @apply text-a-orange-fe5000 border-a-orange-fe5000;

        &:hover {
            @apply ring-a-orange-fe5000;
        }
    }

    &.btn-orange-2 {
        @apply bg-a-orange-f36e21 border-a-orange-f36e21;

        &:hover {
            @apply ring-a-orange-f36e21;
        }
    }

    &.btn-outline-orange-2 {
        @apply text-a-orange-f36e21 border-a-orange-f36e21;

        &:hover {
            @apply ring-a-orange-f36e21;
        }
    }

    //#endregion
}
</style>